/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {Uuid} from '../../../../util/uuid';
import {AdnHttpService} from '../../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../../app/common/directives/error/api-error-handler.service';
import {AdnAssetHelperService} from '../../../../util/adn-asset-helper.service';
import {AdnHttpProgressCallback} from '../../../../util/adn-http.service';

/** Angular DI token for the CdnAsset HTTP resource (factory product). */
export class CdnAssetResource {
}

export function createCdnAssetResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile,
  adnAssetHelper: AdnAssetHelperService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const CdnAsset = createAdnHttpResource(send, 'cdnassets', () => localUserProfile, 'cdnAsset');

  CdnAsset.upload = function(assetId: any, data: any, onProgress?: AdnHttpProgressCallback) {
    const resolvedAssetId = assetId || Uuid.generate();
    const upload = onProgress
      ? adnAssetHelper.upload('cdnassets', null, data, resolvedAssetId, onProgress)
      : adnAssetHelper.upload('cdnassets', null, data, resolvedAssetId);
    return upload.then(function(files: any) {
      return _.isArray(files) ? files[0] : files;
    });
  };

  return CdnAsset;
}

export const cdnAssetResourceProvider = {
  provide: CdnAssetResource,
  useFactory: createCdnAssetResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile, AdnAssetHelperService]
};
